// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminUsers .table-responsive {
  overflow: visible;
}

.SuperAdminUsers .react-datepicker-popper {
  z-index: 10000 !important;
}

.SuperAdminUsersDetailsModal {
  overflow-y: auto;
}

.SuperAdminUsersDetailsModal .modal-backdrop {
  z-index: -1;
}

.SuperAdminUsersDetailsGrid {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 8px 16px;
}

.SuperAdminUsersJsonBlock {
  max-height: 280px;
  overflow: auto;
  padding: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: #f8f9fa;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/Users/SuperAdminUsers.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".SuperAdminUsers .table-responsive {\n  overflow: visible;\n}\n\n.SuperAdminUsers .react-datepicker-popper {\n  z-index: 10000 !important;\n}\n\n.SuperAdminUsersDetailsModal {\n  overflow-y: auto;\n}\n\n.SuperAdminUsersDetailsModal .modal-backdrop {\n  z-index: -1;\n}\n\n.SuperAdminUsersDetailsGrid {\n  display: grid;\n  grid-template-columns: 180px 1fr;\n  gap: 8px 16px;\n}\n\n.SuperAdminUsersJsonBlock {\n  max-height: 280px;\n  overflow: auto;\n  padding: 12px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  background: #f8f9fa;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
